exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".defaultContent{margin-bottom:20px}.header{position:relative}.header:after{display:block;content:\" \";clear:both}.header .edit{display:block;float:right;line-height:24px}.menu{margin:0;padding:0;list-style-type:none}.menu>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.menu>li:first-child{border-top:0}.menu>li a:hover{text-decoration:none}.CampaignDetail-defaultContent-1lCvQ{margin-bottom:20px}.CampaignDetail-header-2Zedy{position:relative}.CampaignDetail-header-2Zedy:after{display:block;content:\" \";clear:both}.CampaignDetail-header-2Zedy .CampaignDetail-edit-1wMOg{display:block;float:right;line-height:24px}.CampaignDetail-menu-3T3Lq{margin:0;padding:0;list-style-type:none}.CampaignDetail-menu-3T3Lq>li{border-top:1px solid #546d79;padding:12px 0 10px;text-transform:uppercase;font-weight:400;white-space:nowrap}.CampaignDetail-menu-3T3Lq>li:first-child{border-top:0}.CampaignDetail-menu-3T3Lq>li a:hover{text-decoration:none}", ""]);

// exports
exports.locals = {
	"defaultContent": "CampaignDetail-defaultContent-1lCvQ",
	"header": "CampaignDetail-header-2Zedy",
	"edit": "CampaignDetail-edit-1wMOg",
	"menu": "CampaignDetail-menu-3T3Lq"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/satisfaction/components/CampaignDetail.less
// module id = 1750
// module chunks = 0